import { clsx } from 'clsx'
import { useImageDownload } from '../../../hooks'
import { avatarBlock, faceDirection } from './index.css'

export const Avatar = (props: {
  avatar?: string | null
  faceDirection?: 'left' | 'right'
  className?: string
}) => {
  const { image, isLoaded } = useImageDownload({
    url: props.avatar,
    retryCount: 3,
    retryDelayMs: 300,
    placeholder: '/avatar.svg',
  })

  return (
    <img
      className={clsx(
        avatarBlock,
        !isLoaded && props.faceDirection
          ? faceDirection[props.faceDirection]
          : null,
        props.className,
      )}
      src={image}
      alt=''
    />
  )
}
